import { render, staticRenderFns } from "./UserLanguages.vue?vue&type=template&id=3de80818"
import script from "./UserLanguages.js?vue&type=script&lang=js&external"
export * from "./UserLanguages.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports